// extracted by mini-css-extract-plugin
module.exports = {"innerContainer":"MetricsView-module__innerContainer__1JGR6"};